import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ListIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M3 5a1 1 0 0 0 0 2 1 1 0 0 0 0-2Zm5 0a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2H8Zm0 6a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H8Zm-1 7c0-.6.4-1 1-1h13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm-5-6c0-.6.4-1 1-1a1 1 0 1 1 0 2 1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2Z" />
  </Icon>
));
export default ListIcon;
